import _get from 'lodash/get'
import _curry from 'lodash/curry'

const getLocalState = (state) => _get(state, 'gallery')
const getPropFromState = _curry((prop, state) => _get(getLocalState(state), prop))
export const getTemporaryAnchor = getPropFromState('temporaryAnchor')
export const getSelectedCommentId = getPropFromState('selectedCommentId')
export const getPosition = getPropFromState('position')
export const getIsCommenting = getPropFromState('isCommenting')
